import { ItemCategory } from "../../../types";
import { Product } from "./types";

// adapter IS util functions
export const getItemCategory = (item: Product) => {
  const keywords = ["outlet", "bazar", "sale"];
  const regex = new RegExp(keywords.join("|"), "i"); // cria: /outlet|bazar|sale/i

  const value = item?.categories

  if (value) {
    const textToTest = Array.isArray(value) ? value.join(" ") : String(value);
    const match = textToTest.match(regex);

    if (match) {
      return match[0].toLowerCase() as ItemCategory;
    }
  }
  return "Coleção";
}

export const getItemCategory2 = (item: Product): string => {
  const avoidList = /outlet|bazar|sale/i;
  const lastCategory = item.categories?.[item.categories.length - 1] ?? "";
  const categoryHierarchy = lastCategory.split("/").filter(Boolean);
  const deepestCategory = [...categoryHierarchy].reverse().find(c => !avoidList.test(c)) ?? "";
  return deepestCategory && deepestCategory[0].toUpperCase() + deepestCategory.slice(1).toLowerCase();
};